// import IconTip from '-!babel-loader!svg-react-loader!svg/icon_tip.svg?name=IconTip';
import IconTip from '../../../svg/icon_tip.svg';

export default IconTip;
